import React from 'react'
import "./SocialMedia.css"
import { FaInstagram, FaFacebookF, FaYoutube, FaTwitter, FaLinkedinIn } from "react-icons/fa6";

import { Link } from 'react-router-dom';


const SocialMedia = () => {
    return (
        <>
            <div className="media-items">
                {/* <Link to={"//facebook.com"}>
                    <FaTwitter />
                </Link> */}
                <Link to={"https://www.instagram.com/pukhyapvtltd/"}>
                    <FaInstagram />
                </Link>
                <Link to={"//facebook.com"}>
                    <FaFacebookF />
                </Link>
                <Link to={"https://www.youtube.com/@PUKHYAPRIVATELIMITED"}>
                    <FaYoutube />
                </Link>
                <Link to={"https://www.linkedin.com/company/pukhya-pvt-ltd/"}>
                    <FaLinkedinIn />
                </Link>
            </div>
        </>
    )
}

export default SocialMedia